export const getPaymentTermsTooltip = (
  paymentTermsDisplay,
  basisDateDisplay
) => {
  const normalizedTerms = paymentTermsDisplay?.trim();
  const normalizedBasis = basisDateDisplay?.trim().toLowerCase();
  const netMatch = normalizedTerms?.match(/^Net\s+(\d+)$/i);

  if (netMatch) {
    const days = netMatch[1];

    if (normalizedBasis === 'upon delivery') {
      return `Payment is due ${days} days after delivery.`;
    }

    if (normalizedBasis === 'on approval') {
      return `Payment is due ${days} days after approval.`;
    }

    return `Payment is due ${days} days after the terms basis date.`;
  }

  return 'These are the payment terms for this order.';
};

export const getTermsBasisTooltip = (basisDateDisplay) => {
  const normalizedBasis = basisDateDisplay?.trim().toLowerCase();

  if (normalizedBasis === 'upon delivery') {
    return 'The payment terms start on the delivery date.';
  }

  if (normalizedBasis === 'on approval') {
    return 'The payment terms start on the order approval date.';
  }

  return 'This is the date the payment terms are counted from.';
};

export const getPaymentMethodTooltip = (paymentMethodDisplay) => {
  const normalizedMethod = paymentMethodDisplay?.trim().toLowerCase();

  if (normalizedMethod === 'leaf pay') {
    return 'Payment is collected through Leaf Trade using the bank account selected at checkout.';
  }

  if (normalizedMethod === 'invoiced by vendor') {
    return 'The vendor invoices you directly based on your payment agreement.';
  }

  return 'This is how payment will be handled for the order.';
};
